import server from './http'

const homeApi = {
     indexDatum: (param) => server.post('/portal/indexDatum', param),   // 用工数据
     market: (param) => server.post('/portal/market', param),           // 百工市场
     orderStats: (param) => server.post('/portal/orderStats', param),   // 订单中心统计
     getFlexRechargeProof: (param) => server.post('/workbench/getRechargeProof', param),   // 灵工、商户支付凭证
     orderList: (param) => server.post('/portal/orderList', param),     // 订单中心列表
     delOrder: (param) => server.post('/portal/deleteOrder', param),     // 删除订单
     exportOrderDetail: (param) => server.post('/portal/exportOrderDetail', param), // 导出订单明细
     invoiceList: (param) => server.post('/invoice/invoiceList', param),     // 开票列表
     industrySceneWorkTree: (param) => server.post('/portal/industrySceneWorkTree', param), // 行业岗位树
     getSceneWork: (param) => server.post('/portal/getSceneWork', param), // 已选行业岗位
     saveSceneWork: (param) => server.post('/portal/saveSceneWork', param), // 保存行业岗位
}

export default homeApi

